// extracted by mini-css-extract-plugin
export default {"XClick":"SearchBar_XClick__i7J-K","searchInputContainer":"SearchBar_searchInputContainer__oI9b+","searchInput":"SearchBar_searchInput__AuSk4"};